import { DividerSchema } from '@/views/sports/components/Divider/styles/Divider.styles';

export const dividerStyles: DividerSchema = {
  boxWrapper: {
    borderColor: 'blackAlpha.400',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    sx: {
      '&&': {
        my: '4',
      },
    }
  },
};
